import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Application = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 12.1244V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6H13.9992L15.7232 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V9.80458L18 12.1244ZM12.2752 8H7V10H11.0366C11.1144 9.54403 11.315 9.114 11.6212 8.75872L12.2752 8ZM11 11H7V13H11.3071C11.1109 12.6374 10.9996 12.222 11 11.7804V11ZM14.9118 14.3447C15.2918 14.3447 15.6628 14.2603 16 14.1022V16H7V14H12.278C12.6544 14.2184 13.0915 14.3438 13.5576 14.3447H14.9118Z"
                fill={color}
            />
            <path
                d="M19.1781 3.00006C19.0172 3.00231 18.8648 3.07374 18.7596 3.1958L18.1443 3.90956L20.2917 6.05702L20.9616 5.28027H20.9622C21.1545 5.05697 21.1422 4.72287 20.9335 4.51476L19.5836 3.1643C19.4762 3.05687 19.3299 2.99782 19.1781 3.00006H19.1781ZM17.5559 4.59245L13.1361 9.71978C13.0484 9.82158 13 9.95208 13 10.0865V11.437C12.9994 11.7474 13.2509 11.9994 13.5613 12H14.9118C15.076 12 15.2318 11.9286 15.3387 11.8037L19.7039 6.74044L17.5559 4.59245Z"
                fill={color}
            />
        </g>
    </StarryUIIcon>
);
